export const urls = {
  changeFollowStatus: "/splx_changeFollowStatus",
  masterTradersPages: "/splx_getMasterTradersPagesCount",
  masterTradersByPage: "/splx_getMasterTradersPage",
};
